export default (url: string) => {
  if (url.includes('embed') || url.includes('player')) {
    return url;
  }

  if (url.includes('youtube')) {
    return `https://www.youtube-nocookie.com/embed/${url.split('v=')[1]}`;
  }

  if (url.includes('youtu.be')) {
    return `https://www.youtube-nocookie.com/embed/${url.split('be/')[1]}`;
  }

  if (url.includes('vimeo')) {
    return `https://player.vimeo.com/video/${url.split('vimeo.com/')[1]}`;
  }

  if (url.includes('giraffe360') || url.includes('matterport')) {
    return url;
  }

  return '';
};
